import NetworkHandler from 'utils/network';
import config from 'config';

function getDriverSettingType({ params }) {
    return NetworkHandler.get(`${config.getUrl('driver_setting_type')}`, {
        params: { ...params },
    });
}
function createDriverSettingType({ params }) {
    return NetworkHandler.post(`${config.getUrl('driver_setting_type')}`, {
        ...params,
    });
}
function deleteDriverSettingType({ params }) {
    const { routeId, id } = params;
    return NetworkHandler.delete(`${config.getUrl('driver_setting_type')}/${routeId}/${id}`);
}
function exportDriverSettingType({ params }) {
    const { routeId, ...rest } = params;
    return NetworkHandler.get(`${config.getUrl('bus_route')}/${routeId}/driver-setting`, {
        params: { ...rest, export: true },
    });
}
export default {
    getDriverSettingType,
    createDriverSettingType,
    deleteDriverSettingType,
    exportDriverSettingType,
};
